import { DashboardCumulativeData } from "interface/admin/interface.dashboard";
import { TotlaBoxWrap } from "style/admin/inquiry";
import {
  getTotalCountFromDateGroups,
  getTotalUserCount,
} from "utils/dashboard.util";
import { formatNumber } from "utils/util";

interface DashboardTotalBoxProps {
  data: DashboardCumulativeData;
}

const DashboardTotalBox = ({ data }: DashboardTotalBoxProps) => {
  return (
    <TotlaBoxWrap>
      <div className="box-item">
        <p className="key">총 회원</p>
        <h3 className="value">
          {formatNumber(getTotalUserCount(data.userTotalCount))}
        </h3>
      </div>
      <div className="box-item">
        <p className="key">월간 활성 회원</p>
        <h3 className="value">
          {formatNumber(getTotalUserCount(data.activeUserCount))}
        </h3>
      </div>
      <div className="box-item">
        <p className="key">간이측정</p>
        <h3 className="value">
          {formatNumber(getTotalCountFromDateGroups(data.simpleMeasureCount))}
        </h3>
      </div>
      <div className="box-item">
        <p className="key">간이검사</p>
        <h3 className="value">
          {formatNumber(getTotalCountFromDateGroups(data.simpleTestCount))}
        </h3>
      </div>
      <div className="box-item">
        <p className="key">심화검사</p>
        <h3 className="value">
          {formatNumber(getTotalCountFromDateGroups(data.deepTestCount))}
        </h3>
      </div>
      <div className="box-item">
        <p className="key">후기</p>
        <h3 className="value">
          {formatNumber(getTotalCountFromDateGroups(data.reviewCount))}
        </h3>
      </div>
    </TotlaBoxWrap>
  );
};

export default DashboardTotalBox;
